import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from './apiConfig';

const API = API_BASE_URL;

class PaymentService {
  getHeaders() {
    const token = authService.getAccessToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    };
  }

  // Create a payment intent
  async createIntent(data) {
    const response = await axios.post(`${API}/payments/intents`, data, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Get a payment intent by ID
  async getIntent(intentId) {
    const response = await axios.get(`${API}/payments/intents/${intentId}`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Cancel a payment intent
  async cancelIntent(intentId) {
    const response = await axios.post(`${API}/payments/intents/${intentId}/cancel`, {}, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Confirm payment using mock provider
  async confirmMock(intentId, outcome = 'success') {
    const response = await axios.post(`${API}/payments/mock/confirm/${intentId}`, 
      { outcome },
      { headers: this.getHeaders() }
    );
    return response.data;
  }

  // Get funding summary for an entity
  async getFundingSummary(entityType, entityId, currency = 'USD') {
    const response = await axios.get(`${API}/payments/funding/summary`, {
      params: { entity_type: entityType, entity_id: entityId, currency },
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Get payment history (auth required)
  async getHistory() {
    const response = await axios.get(`${API}/payments/history`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Lookup payments by email (guest)
  async lookupPayments(payerEmail, reference = null) {
    const response = await axios.post(`${API}/payments/lookup`, 
      { payer_email: payerEmail, reference },
      { headers: this.getHeaders() }
    );
    return response.data;
  }

  // Get available providers
  async getProviders() {
    const response = await axios.get(`${API}/payments/providers`);
    return response.data;
  }

  // Helper: Open payment page
  openPayment({ purpose, entityType, entityId, suggestedAmount, currency = 'USD', allowEncryption = false, returnUrl }) {
    const params = new URLSearchParams({
      purpose,
      entity_type: entityType,
      entity_id: entityId,
      amount: suggestedAmount || '',
      currency,
      allow_encryption: allowEncryption
    });
    
    if (returnUrl) {
      params.set('return_url', returnUrl);
    }
    
    return `/payment?${params.toString()}`;
  }
}

export default new PaymentService();
